import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=31284fe2&scoped=true"
import script from "./FacebookIcon.vue?vue&type=script&lang=ts"
export * from "./FacebookIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31284fe2",
  null
  
)

export default component.exports